import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { theme } from '../../theme';

export function Header({ onNavigate, currentScreen }) {
  const { isAuthenticated, user, login, logout } = useAuth();

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: theme.maxWidth,
      background: theme.bgCard,
      borderBottom: `1px solid ${theme.border}`,
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 100,
    }}>
      <div
        onClick={() => onNavigate('landing')}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
      >
        <span style={{ fontSize: '20px' }}>🔧</span>
        <span style={{ fontSize: '18px', fontWeight: 700, color: theme.accent }}>
          Prenta
        </span>
      </div>

      {isAuthenticated ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '13px', color: theme.textSecondary }}>
            {user?.name?.split(' ')[0]}
          </span>
          <img
            src={user?.picture}
            alt=""
            style={{ width: '32px', height: '32px', borderRadius: '50%' }}
            onClick={() => onNavigate('my-page')}
          />
        </div>
      ) : (
        <button
          onClick={login}
          style={{
            background: theme.accent,
            color: '#000',
            border: 'none',
            padding: '8px 16px',
            borderRadius: theme.radiusSm,
            fontWeight: 600,
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          Skrá inn
        </button>
      )}
    </header>
  );
}
